import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import SearchForm from "./common/searchForm";
import TabMenu from "./common/tabMenu";
import Searched from "./common/searched";
import CloseButton from "./common/closeButton";
import MemberList from "./inviteModal/memberList";
import InviteActions from "./inviteModal/inviteActions";

import { AiOutlineClose } from "react-icons/ai";

import { useModal } from "../../../../../../../hooks/useModal";
import { ButtonStateStyle, formatPhoneNumber, memberName } from "../../../common/function/project";

import { ModalBackground, ParticipantInviteModalContainer } from "../../../common/styled/project";

const InviteModal = ({
  changeModalState,
  project,
  participantList,
  getParticipantList,
  participant,
}) => {
  const isGrp = project?.gbn === "G";
  const user = useSelector((state) => state?.user?.data[0]);
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { modal, openModal, closeModal } = useModal();

  const [isSearch, setIsSearch] = useState(false);
  const [searched, setSearched] = useState("");
  const [originCmpnyMber, setOriginCmpnyMber] = useState([]);
  const [mberList, setMberList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [mberTotal, setMberTotal] = useState(0);
  const [chkMberList, setChkMberList] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [searchedList, setSearchedList] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  // 페이지 조건 생성
  const getSearchCond = (number) => {
    const pageSize = isMobile ? 7 : 10;
    const pageNumber = number - 1;

    return {
      delYn: "N",
      offset: pageNumber * pageSize,
      pageNumber: pageNumber,
      pageSize,
      paged: true,
    };
  };

  const getSearchMberCond = (number) => {
    const pageNumber = number - 1;
    return {
      page: pageNumber,
      size: 10,
    };
  };

  // 멤버 데이터 변환
  const transformMemberData = (item, isGroup = false) => {
    if (isGroup) {
      return {
        mberNm: item.nickNm || null,
        mberNo: item.mberNo,
        cmpnyNm: null,
        cmpnyNo: project?.orgNo,
        moblphonNo: null,
      };
    }
    return {
      mberNm: item.mberNm || null,
      mberNo: item.mberNo,
      cmpnyNm: project?.orgNm,
      cmpnyNo: item.cmpnyNo,
      moblphonNo: item.mberTel,
    };
  };

  // 초대 가능한 멤버 필터링
  const getInvitableMembers = (members) => {
    return members.filter(
      (mber) =>
        mber.mberNm && !participantList.some((participant) => participant.mberNo === mber.mberNo),
    );
  };

  // 초대 가능 여부 확인
  const isInvitable = (mber) => {
    return (
      mber.mberNm && !participantList.some((participant) => participant.mberNo === mber.mberNo)
    );
  };

  useEffect(() => {
    if (isGrp) {
      getGrpMber();
    } else {
      getCmpnyMber();
      getSearchedParticipantList();
    }
  }, [isGrp]);

  // 저장된 사람 클릭 시 검색
  const handleSearchedMber = async (item) => {
    if (!item) return;
    setSearched(item.searchWord);

    try {
      const response = await axios.post("/api/cmpnyMbers", {
        mberNo: item.mberNo,
        mberNm: item.searchWord,
        cmpnyNo: item.refeCmpnyNo,
      });

      if (response.status === 200) {
        const transformedList = response.data.content.map((item) => transformMemberData(item));
        setMberList(transformedList);
        setMberTotal(response.data.totalElements);
        setIsSearch(true);
      }
    } catch (error) {
      console.error("검색된 멤버 조회 실패:", error);
    }
  };

  // 회사 멤버 조회
  const getCmpnyMber = async () => {
    try {
      const response = await axios.post("/api/cmpnyMbers", {
        cmpnyNo: participant.orgNo,
      });

      if (response.status === 200) {
        const transformedList = (response.data.content || []).map((item) =>
          transformMemberData(item),
        );
        const pageSize = isMobile ? 7 : 10;

        setOriginCmpnyMber(transformedList);
        setMberList(transformedList.slice(0, pageSize));
        setMberTotal(response.data.totalElements);
      }
    } catch (error) {
      console.error("회사 멤버 조회 실패:", error);
    }
  };

  // 사용자 검색
  const getSearchMber = async (number = 1) => {
    try {
      const response = await axios.post("/api/cmpnyMbers", {
        fullMberNm: searched,
        ...getSearchMberCond(number),
      });

      if (response.status === 200 && response.data) {
        const transformedList = response.data.content.map((item) => ({
          mberNm: item.mberNm,
          mberNo: item.mberNo,
          cmpnyNo: item.cmpnyNo,
          cmpnyNm: item?.cmpnyNm || "",
          moblphonNo: item.mberTel,
        }));

        setMberList(transformedList);
        setMberTotal(response.data.totalElements);
      } else {
        setMberList([]);
        setMberTotal(0);
      }
    } catch (error) {
      console.error("멤버 검색 실패:", error);
      setMberList([]);
      setMberTotal(0);
    }
  };

  // 모임 멤버 조회
  const getGrpMber = async (number = 1) => {
    try {
      const response = await axios.post("/api/groupMberList", {
        groupNo: project?.orgNo,
        nickNm: searched,
        ...getSearchCond(number),
      });

      if (response.status === 200) {
        const transformedList = response.data.content.map((item) =>
          transformMemberData(item, true),
        );
        setMberList(transformedList);
        setMberTotal(response.data.totalElements);
      }
    } catch (error) {
      console.error("그룹 멤버 조회 실패:", error);
    }
  };

  // 초대한 사람 기록 조회
  const getSearchedParticipantList = async () => {
    if (!participant?.orgNo) return;

    try {
      const response = await axios.post("/api/searchedParticipantList", {
        cmpnyNo: participant.orgNo,
      });

      if (response.status === 200 && response.data.length > 0) {
        const filteredData = response.data.filter((item) => item.cmpnyNo !== participant.orgNo);
        setSearchedList(filteredData);
      }
    } catch (error) {
      console.error("검색 기록 조회 실패:", error);
    }
  };

  // 체크박스 상태 초기화
  const resetCheckboxState = () => {
    setIsAllChecked(false);
    setChkMberList([]);
  };

  // 페이지네이션 변경
  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    resetCheckboxState();

    if (isGrp) {
      getGrpMber(pageNumber);
      return;
    }

    if (searched) {
      getSearchMber(pageNumber);
      return;
    }

    const pageSize = isMobile ? 7 : 10;
    const startIndex = (pageNumber - 1) * pageSize;

    if (tabIndex === 0) {
      setMberList(originCmpnyMber.slice(startIndex, startIndex + pageSize));
    } else {
      const transformedSearchedList = searchedList.map((item) => ({
        mberNm: item.searchWord,
        mberNo: item.mberNo,
        cmpnyNo: item.cmpnyNo,
        cmpnyNm: item.cmpnyNm,
        moblphonNo: item.moblphonNo,
      }));
      setMberList(transformedSearchedList.slice(startIndex, startIndex + pageSize));
      setMberTotal(searchedList.length);
    }
  };

  const handleSearch = () => {
    if (!searched?.trim()) {
      toast.error("검색어를 입력해 주세요.");
      return;
    }

    setIsSearch(true);
    isGrp ? getGrpMber() : getSearchMber();
  };

  // 멤버 초대
  const handleInvite = async (list) => {
    try {
      const requestBody = list.map((item) => ({
        projectNo: project?.projectNo,
        gbn: project?.gbn,
        mberNo: item.mberNo,
        orgNo: item.cmpnyNo,
        partiType: isGrp || project.orgNo === item.cmpnyNo ? "I" : "O",
        pinnedYn: "N",
        delYn: "N",
        createMberId: user.mberNo,
        updateMberId: user.userName,
      }));

      const response = await axios.put("/api/participants", requestBody);

      if (response.status === 200) {
        const promises = [getParticipantList(project)];

        if (!isGrp) {
          promises.push(...list.map((item) => handleSaveSearched(item)));
        }

        await Promise.all(promises);

        const successMessage =
          list.length > 1
            ? "모든 멤버가 성공적으로 초대되었습니다."
            : "해당 멤버가 성공적으로 초대되었습니다.";
        toast.success(successMessage);
        resetCheckboxState();
      }
    } catch (error) {
      console.error("멤버 초대 실패:", error);
      toast.error("멤버 초대 중 오류가 발생했습니다.");
    } finally {
      closeModal();
    }
  };

  // 초대한 사람 기록 저장
  const handleSaveSearched = async (item) => {
    try {
      const response = await axios.put("/api/saveSearchedParticipantList", {
        cmpnyNo: participant.orgNo,
        searchWord: item.mberNm,
        refeMberNo: item.mberNo,
        refeCmpnyNo: item.cmpnyNo,
        delYn: "N",
        createMberId: user.userName,
        updateMberId: user.userName,
      });

      if (response.status !== 200) {
        console.warn("검색 기록 저장 실패:", response);
      }
    } catch (error) {
      console.error("검색 기록 저장 중 오류:", error);
    }
  };

  // 체크박스 개별 처리
  const handleCheck = (mber) => {
    if (!isInvitable(mber)) return;

    const isAlreadyChecked = chkMberList.some((chkMber) => chkMber.mberNo === mber.mberNo);
    const updated = isAlreadyChecked
      ? chkMberList.filter((chkMber) => chkMber.mberNo !== mber.mberNo)
      : [...chkMberList, mber];

    setChkMberList(updated);
    setIsAllChecked(updated.length === getInvitableMembers(mberList).length);
  };

  // 전체 선택/해제 토글
  const handleCheckAll = (e) => {
    if (e.target.checked) {
      const invitableMembers = getInvitableMembers(mberList);
      setChkMberList(invitableMembers);
      setIsAllChecked(true);
    } else {
      resetCheckboxState();
    }
  };

  const isChecked = (mberNo) => {
    return chkMberList.some((mber) => mber.mberNo === mberNo);
  };

  // 초대 확인 모달 열기
  const handleModalOpen = (memberList = []) => {
    const invitableMembers = getInvitableMembers(memberList);

    if (invitableMembers.length === 0) {
      toast.error("초대 가능한 멤버가 존재하지 않습니다.");
      return;
    }

    const memberCount = invitableMembers.length;
    const message = `${memberCount === 1 ? "해당" : `${memberCount}명의`} 멤버를 초대하시겠습니까?`;

    openModal({
      isOpen: true,
      type: "confirmation",
      title: "초대",
      message: [message],
      handleConfirm: () => handleInvite(invitableMembers),
      handleCancel: () => closeModal(),
    });
  };

  const changeTabIndex = (idx) => {
    setTabIndex(idx);
    setCurrentPage(1);

    const pageSize = isMobile ? 7 : 10;

    if (idx === 0) {
      setMberList(originCmpnyMber.slice(0, pageSize));
    } else {
      const transformedSearchedList = searchedList.map((item) => ({
        mberNm: item.searchWord,
        mberNo: item.mberNo,
        cmpnyNo: item.cmpnyNo,
        cmpnyNm: item.cmpnyNm,
        moblphonNo: item.moblphonNo,
      }));
      setMberList(transformedSearchedList.slice(0, pageSize));
      setMberTotal(searchedList.length);
    }
  };

  return (
    <>
      {modal}
      <ModalBackground onClick={(e) => e.target === e.currentTarget && changeModalState("")}>
        <ParticipantInviteModalContainer>
          <div>
            <CloseButton changeModalState={changeModalState} />
            <SearchForm
              isGrp={isGrp}
              searched={searched}
              setSearched={setSearched}
              handleSearch={handleSearch}
            />
            {!isSearch && !isGrp && searchedList.length > 0 && (
              <Searched searchedList={searchedList} handleSearchedMber={handleSearchedMber} />
            )}
            {!isSearch && !isGrp && (
              <TabMenu
                tabs={[project.orgNm, "외부업체"]}
                activeIndex={tabIndex}
                onChange={changeTabIndex}
              />
            )}
            <MemberList
              isGrp={isGrp}
              mberList={mberList}
              isAllChecked={isAllChecked}
              handleCheckAll={handleCheckAll}
              isChecked={isChecked}
              handleCheck={handleCheck}
              isSearch={isSearch}
              participantList={participantList}
              handleModalOpen={handleModalOpen}
              memberName={memberName}
              formatPhoneNumber={formatPhoneNumber}
              ButtonStateStyle={ButtonStateStyle}
              isInvitable={isInvitable}
            />
            <InviteActions
              mberTotal={mberTotal}
              chkMberList={chkMberList}
              handleModalOpen={handleModalOpen}
              currentPage={currentPage}
              isMobile={isMobile}
              pageSize={isMobile ? 7 : 10}
              onPageChange={onPageChange}
            />
          </div>
        </ParticipantInviteModalContainer>
      </ModalBackground>
    </>
  );
};

export default InviteModal;
